import { getCompanyShortName, getDateString, numberConversion } from "../utils"
import { RadioButton } from "primereact/radiobutton"

import './index.css'


const PastSellerPOsTransactions = (props) => {
    const { pastPOs, isPrevSelPOMaterialTransactionsLoading, PMCompanyConfig, canApplyPastValues, appliedValue, identifier } = props

    if (!pastPOs || pastPOs?.length === 0) {
        return <p className="text-center text-xs" >No Past POs Found!</p>
    }

    if (isPrevSelPOMaterialTransactionsLoading) {
        return <p className="text-center">Loading...</p>
    }

    return (
        <div className="past-pos-table">
            <h4 className="text-center">Past Seller POs</h4>
            <table className="custom-table">
                <thead >
                    <tr className="custom-table-tr">
                        <th className="custom-th">Sr.No</th>
                        <th className="custom-th">Branch Name</th>
                        <th className="custom-th">Seller</th>
                        <th className="custom-th">Date</th>
                        <th className="custom-th">Lead Time</th>
                        <th className="custom-th">Qty</th>
                        <th className="custom-th">Seller Price</th>
                        { canApplyPastValues ? <th className="custom-th"></th> : null }
                    </tr>
                </thead>
                <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }}>
                    {
                        pastPOs.map((eachPO, index) => {
                            let isApplied = false
                            if(appliedValue && eachPO.leadTime === appliedValue.quotLeadTime && eachPO.unitPrice === appliedValue.quotUnitPrice && eachPO.listPrice === appliedValue.quotListPrice){
                                isApplied = true
                            }
                            return (
                                <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }} key={`app-inst-history${eachPO.sellerPOItemId}`} >
                                    <td className="custom-td">{index + 1}</td>
                                    <td className="custom-td">{eachPO.branchName}</td>
                                    <td className="custom-td">{getCompanyShortName(eachPO.companyName)}</td>
                                    <td className="custom-td">{getDateString(eachPO.createdAt)}</td>
                                    <td className="custom-td">{eachPO.leadTime}</td>
                                    <td className="custom-td">{eachPO.qty}</td>
                                    <td className="custom-td">{PMCompanyConfig.currencySymbol}{numberConversion(eachPO.unitPrice)}</td>
                                    { canApplyPastValues ? 
                                        <td className="custom-td" style={{padding: "5px", color: "blue"}}>
                                            { isApplied ? 
                                                <>
                                                    <RadioButton checked={isApplied}/>
                                                    <a style={{color: "green"}}>Applied</a>
                                                </>
                                                :
                                                <>
                                                    <RadioButton checked={false} onChange={() => props.handleApplySellerPOPastValues(identifier, eachPO)}/>
                                                    <a className="cursor-pointer" onClick={() => props.handleApplySellerPOPastValues(identifier, eachPO)}>Apply</a>
                                                </>
                                            }
                                        </td> 
                                        : null 
                                    }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default PastSellerPOsTransactions